export const versionNumber = 'v2.40.2'
